'use client'

import { useEffect } from "react"
import "./globals.css"

// The last resort: the frame every page sits in has failed, so this page brings its own. It
// leans on nothing of the app's but the stylesheet, and follows the theme the person had chosen.
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }, reset: () => void }) {
  useEffect(() => { console.error(error) }, [error])

  useEffect(() => {
    let theme: string | null = null
    try { theme = localStorage.getItem('theme') } catch { /* storage may be closed to the page */ }
    const light = theme === 'light' || (theme === 'system' && !window.matchMedia('(prefers-color-scheme: dark)').matches)
    document.documentElement.classList.toggle('dark', !light)
  }, [])

  const button = 'inline-flex h-10 cursor-pointer items-center justify-center rounded-md px-5 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'

  return (
    <html lang="mn" className="dark">
      <head>
        <title>Алдаа гарлаа | WeSend</title>
      </head>
      <body className="bg-background font-sans text-foreground subpixel-antialiased">
        <main className="flex min-h-dvh flex-col items-center justify-center px-6 py-16 text-center">
          <p className="text-lg font-semibold tracking-tight">WeSend</p>
          <div className="mt-10 w-full max-w-md">
            <p className="inline-flex items-center gap-2 rounded-full border bg-card px-3 py-1 text-xs font-medium text-muted-foreground">
              <span aria-hidden className="size-1.5 rounded-full bg-danger" />Алдаа
            </p>
            <h1 className="mt-5 text-2xl font-semibold leading-tight sm:text-3xl">Хуудсыг ачаалж чадсангүй</h1>
            <p className="mt-3 text-sm leading-6 text-muted-foreground sm:text-base sm:leading-7">
              Уучлаарай, манай талд алдаа гарлаа. Хэдэн хормын дараа дахин оролдоно уу.
            </p>
            <div className="mt-8 flex flex-col justify-center gap-2.5 sm:flex-row">
              <button type="button" onClick={() => reset()} className={`${button} bg-primary text-primary-foreground hover:bg-primary/90`}>Дахин ачаалах</button>
              {/* A plain link: the app's own navigation may be what failed. */}
              <a href="/" className={`${button} border bg-background hover:bg-muted`}>Нүүр хуудас</a>
            </div>
            {error.digest && <p className="mt-8 text-xs text-muted-foreground">Алдааны дугаар: <span className="text-foreground">{error.digest}</span></p>}
          </div>
        </main>
      </body>
    </html>
  )
}
